import {LunarYear} from '../../LunarYear'
import moment from 'moment-timezone'

const Y1974 = new LunarYear(
  moment.tz('1974-01-23 00:00', 'Asia/Seoul'),
  [1, 2, 3, 4, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [30, 30, 29, 30, 29, 29, 30, 29, 29, 30, 30, 29, 30],
  4,
)

export default Y1974
